import {DeviceStat, Platform, DeviceDataItem, PlatformData} from '../../../../../types';
import {TimeInSeconds} from '../../../../../../shared/utils/DateUtils';

export const getHpm = (sec: number, th: number): number =>
    sec ? th / (sec / TimeInSeconds.MINUTE) : 0;

export const getMvp = (sec: number, fc: number, ef: number): number =>
    sec ? (1 - fc / ef) * 100 : 0;

export const getPlatformStats = (platforms: Platform[], stats: PlatformData): DeviceDataItem => {
    const statKeys = Object.values(DeviceStat);
    const initialStats = statKeys.reduce(
        (stats, key) => ({...stats, [key]: 0}),
        // eslint-disable-next-line
        {} as DeviceDataItem
    );

    return platforms.reduce(
        (platformStats, platform) =>
            statKeys.reduce(
                (deviceStats, statKey) => ({
                    ...deviceStats,
                    [statKey]:
                        (platformStats[statKey] || 0) + ((stats[platform] || {})[statKey] || 0)
                }),
                initialStats
            ),
        initialStats
    );
};
